import React from 'react';
import { useTranslation } from 'react-i18next';
import { EiqInput, EiqSelect } from 'eiq-storybook';
import s from '../CapAction.styles';
import { ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES, ACTION_RESOURCE_TYPE_VALUES, ACTION_RESOURCE_NUMBER_OF_STAFF_DEFAULT_VALUES } from '../utils';

export const ResourceNoOfStaffDays = ({ resources, currencyOptions, resource, isAdmin, editableStatus, isCapManager, setValue, errors }) => {
  const { t } = useTranslation();    
  let errorObject = {};
  const isResourceStaffDaysEditable =  editableStatus;  
  const setResourcesValue = (fieldName, val) => {
    const index = resources?.findIndex((item) => resource && (item?.resourceType === ACTION_RESOURCE_TYPE_VALUES.numberOfStaffDays));
    let resourceObj = {};
    if(resource) {
      resourceObj = resource;
      resourceObj[fieldName] = val;
    }else{
      resourceObj = {...ACTION_RESOURCE_NUMBER_OF_STAFF_DEFAULT_VALUES};
      resourceObj.resourceType = ACTION_RESOURCE_TYPE_VALUES.numberOfStaffDays;
      resourceObj[fieldName] = val;
    }
    resourceObj[fieldName] = val;
    const updatedResources = resources ? [...resources] : [];
    if(index === 0 || index !== -1 ){
      updatedResources[index] = resourceObj;
    }else{      
      const resourceIndex = resources?.findIndex((item) => ACTION_RESOURCE_TYPE_VALUES.numberOfStaffDays === item?.resourceType);
      if(resourceIndex === 0 || resourceIndex !== -1 ) updatedResources[resourceIndex] = resourceObj;
      else updatedResources[resources ? resources.length : 0] = resourceObj;
    } 
    setValue('resources', updatedResources);
  };
  if(errors && typeof errors !== 'string'){
    const index = resources?.findIndex((item) => resource && (item?.id === resource?.id && item?.resourceType === ACTION_RESOURCE_TYPE_VALUES.numberOfStaffDays));
    errorObject = errors[index];
  }

  return (
  <>
    <s.ResourceDetailWrapper>
        <s.ResourceTitleLabel className='mandatory'>{t('COLUMN_DESCRIPTION')}</s.ResourceTitleLabel>
        <div className='pr-20'>
            <EiqInput
                type='text'
                id='resourceDescription'
                autoFocus
                wrapperClassName='DescriptionInputWrapper eiqWrapper'
                errorMessage={errorObject?.details}
                value={resource?.details}
                placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                onChange={(e) => setResourcesValue('details', e.target.value)}
                disabled={!isResourceStaffDaysEditable}
            /> 
        </div>
        
        <div className='pr-20 '>
            <s.ResourceTitleLabel className='mandatory'>{t('NUMBER_OFF_STAFF')}</s.ResourceTitleLabel>
                <div>
                  <EiqInput
                    type='number'
                    id='resourceNoOfStaff' 
                    wrapperClassName='InputWrapper resourceInputWrapper eiqWrapper'
                    errorMessage={errorObject?.numberOfStaff}
                    value={resource?.numberOfStaff}
                    placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                    onChange={(e) => setResourcesValue("numberOfStaff", parseInt(e.target.value, 10))}
                    disabled={!isResourceStaffDaysEditable}
                  />
              </div>
          </div>

          
          <s.ResourceFlex>       
          <s.ResourceDropdownWrapper id="noOfDays">
              <EiqSelect 
                label={t('NUMBER_OF')}
                id="noOfDays"
                backspaceRemovesValue={false}
                isClearable={false}
                isDisabled={!isResourceStaffDaysEditable}
                wrapperClass='resourceNoOfWrapper'
                onChange={(_name, option) => {
                  setResourcesValue("staffDayType", option.value);
                }}
                options={ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES}
                placeholder={t('CHOOSE')}
                value={ACTION_RESOURCE_STAFF_DAY_TYPE_VALUES.find(staffDayTypeOption => staffDayTypeOption.value.toLowerCase() === resource?.staffDayType?.toLowerCase())}
                error={errorObject?.staffDayType}
                touched={true}
              />
            </s.ResourceDropdownWrapper>
          
        <div className='rightToDropdown'>
            <s.ResourceTitleLabel className='mandatory'>{t('VALUE_OF_ALL_STAFFS')}</s.ResourceTitleLabel>
                <div>
                  <EiqInput
                    type='number'
                    id='resourceValueOfAllStaff' 
                    wrapperClassName='InputWrapper eiqWrapper'
                    errorMessage={errorObject?.staffDayValue}
                    value={resource?.staffDayValue}
                    placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                    onChange={(e) => setResourcesValue("staffDayValue", parseInt(e.target.value, 10))}
                    disabled={!isResourceStaffDaysEditable}
                  />
              </div>
          </div>
          </s.ResourceFlex>
          
          
          <s.ResourceFlex>             
          <s.ResourceDropdownWrapper id="resourceCurrency">
              <EiqSelect 
                id="resourceCurrency"
                label={t('CURRENCY')}
                backspaceRemovesValue={false}
                isClearable={false}
                isDisabled={!isResourceStaffDaysEditable}
                wrapperClass='resourceNoOfWrapper'
                onChange={(_name, option) => {
                  setResourcesValue("currencyId", option.value);
                }}
                options={currencyOptions}
                placeholder={t('CHOOSE')}
                value={currencyOptions.find(currency => currency.value === resource?.currencyId)}
                error={errorObject?.currencyId}
                touched={true}
              />
            </s.ResourceDropdownWrapper>
         
          
        <div className='rightToDropdown'>
            <s.ResourceTitleLabel className='mandatory'>{t('AVERAGE_DAY_RATE')}</s.ResourceTitleLabel>
                <div>
                  <EiqInput
                    type='number'
                    id='resourceAverageDayRate' 
                    wrapperClassName='InputWrapper eiqWrapper'
                    errorMessage={errorObject?.averageDayRate}
                    value={resource?.averageDayRate}
                    placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                    onChange={(e) => setResourcesValue("averageDayRate", parseFloat(e.target.value, 10))}
                    disabled={!isResourceStaffDaysEditable}
                  />
              </div>
          </div>
          </s.ResourceFlex>
          
          <div className='pr-20 '>
              <s.ResourceTitleLabel className='mandatory'>{t('TOTAL_COST')}</s.ResourceTitleLabel>
                  <div>
                    <EiqInput
                      type='number'
                      id='resourceTotalCost' 
                      wrapperClassName='InputWrapper resourceInputWrapper eiqWrapper'
                      errorMessage={errorObject?.costs}
                      value={resource?.costs}
                      placeholder={t('CLICK_HERE_TO_ENTER_TEXT')}
                      onChange={(e) => setResourcesValue("costs", parseFloat(e.target.value, 10))}
                      disabled={!isResourceStaffDaysEditable}
                    />
                </div>
            </div>
    </s.ResourceDetailWrapper> 
  </>)

};
